/* eslint-disable no-console */

/**
 * @module M/control/ManageDeraControl
 */

import ManageDeraImplControl from 'impl/managederacontrol';
import template from 'templates/managedera';

export default class ManageDeraControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(config) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(ManageDeraImplControl)) {
      M.exception('La implementación usada no puede crear controles ManageDeraControl');
    }
    // 2. implementation of this control
    const impl = new ManageDeraImplControl();
    super(impl, 'ManageDera');

    this.groupLayers = config;

    this.zIndexToSet = 2000;

  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    if (!M.template.compileSync) { // JGL: retrocompatibilidad Mapea4
      M.template.compileSync = (string, options) => {
        let templateCompiled;
        let templateVars = {};
        let parseToHtml;
        if (!M.utils.isUndefined(options)) {
          templateVars = M.utils.extends(templateVars, options.vars);
          parseToHtml = options.parseToHtml;
        }
        const templateFn = Handlebars.compile(string);
        const htmlText = templateFn(templateVars);
        if (parseToHtml !== false) {
          templateCompiled = M.utils.stringToHtml(htmlText);
        } else {
          templateCompiled = htmlText;
        }
        return templateCompiled;
      };
    }

    return new Promise((success, fail) => {
      const html = M.template.compileSync(template);
      // Añadir código dependiente del DOM

      this.divMenus = html.querySelectorAll('div#divMenus')[0];
      this.divCapasCargadas = html.querySelectorAll('div#divCapasCargadas')[0];
      this.divNoCapas = html.querySelectorAll('div#noCapas')[0];
      this.divCapasFondo = html.querySelectorAll('div#divCapasFondo')[0];
      this.contentCapasFondo = html.querySelectorAll('div#contentCapasFondo')[0];

      this.addMenus();

      this.addEvents(html);

      success(html);


    });
  }



  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {
    // calls super to manage de/activation
    super.activate();

  }
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {
    // calls super to manage de/activation
    super.deactivate();

  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-managedera button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof ManageDeraControl;
  }

  // Add your own functions

  addEvents(html) {

    this.panelsBottomRight = this.map_.getPanels().filter(obj => obj.position == '.m-bottom.m-right');

    // MOVEMOS LOS PANELES YA QUE EL PANEL DE MANAGEDERA ESTARÁ ABIERTO AL INICIO
    this.panelsBottomRight.forEach(panel => {
      panel.getTemplatePanel().classList.toggle('panelBottomRightOpened');
    });

    this.grupos = html.querySelectorAll('div.GroupDera');
    this.buttonsCheckLayers = html.querySelectorAll('div.GroupDera button.g-cartografia-check2');
    this.buttonsRecycleBin = html.querySelectorAll('div.GroupDera button.g-cartografia-papelera');
    this.pest_divMenus = html.querySelectorAll('label#pest_divMenus')[0];
    this.pest_divCapasCargadas = html.querySelectorAll('label#pest_divCapasCargadas')[0];
    this.pest_divCapasFondo = html.querySelectorAll('label#pest_divCapasFondo')[0];
    this.toponimiaOnOff = html.querySelectorAll('input#toponimiaOnOff')[0];

    this.pest_divMenus.addEventListener('click', () => {
      if (!this.pest_divMenus.classList.contains('actived')) {
        this.divCapasCargadas.style.display = 'none';
        this.divCapasFondo.style.display = 'none';
        this.divMenus.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divMenus.classList.toggle('pest_legend');
        this.pest_divMenus.classList.toggle('actived');
      }
    });

    this.pest_divCapasCargadas.addEventListener('click', () => {
      if (!this.pest_divCapasCargadas.classList.contains('actived')) {
        this.divMenus.style.display = 'none';
        this.divCapasFondo.style.display = 'none';
        this.divCapasCargadas.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divCapasCargadas.classList.toggle('pest_legend');
        this.pest_divCapasCargadas.classList.toggle('actived');
      }
    });

    this.pest_divCapasFondo.addEventListener('click', () => {
      if (!this.pest_divCapasFondo.classList.contains('actived')) {
        this.divMenus.style.display = 'none';
        this.divCapasCargadas.style.display = 'none';
        this.divCapasFondo.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divCapasFondo.classList.toggle('pest_legend');
        this.pest_divCapasFondo.classList.toggle('actived');
      }
    });

    this.toponimiaOnOff.addEventListener('change', () => {
      if (this.toponimiaOnOff.checked) {
        this.map_.getLayers({ name: "CDAU_toponimia" })[0].setVisible(true);
      } else {
        this.map_.getLayers({ name: "CDAU_toponimia" })[0].setVisible(false);
      }
    });


    //  FUNCIONALIDAD DESPLEGAR-OCULTAR LISTA CAPAS

    this.grupos.forEach(grupo => {
      grupo.addEventListener('click', (evt) => {
        if (evt.target.tagName == 'H3') {
          let itemsVisibles = html.querySelectorAll('.visible');
          if (itemsVisibles.length != 0) {
            if (!itemsVisibles[0].id.includes(grupo.id)) {
              itemsVisibles[0].classList.toggle('visible');
              itemsVisibles[0].classList.toggle('oculta');
            }
          }
          let id = "layers_";
          id += grupo.id;
          html.querySelectorAll('div#' + id)[0].classList.toggle('oculta');
          html.querySelectorAll('div#' + id)[0].classList.toggle('visible');

          if (html.querySelectorAll('div#' + id)[0].classList.contains('visible')) {
            evt.target.title = 'Oculta las capas del grupo ' + grupo.id;
          } else {
            evt.target.title = 'Despliega las capas del grupo ' + grupo.id;
          }
        }

        //  SI HACEMOS CLICK SOBRE EL NOMBRE DE LA CAPA SE SELECCIONA O SE DESELECCIONA EN EL MAPA

        if (evt.target.tagName == 'P') {
          evt.target.nextElementSibling.click();
          let layerName = evt.target.parentNode.id.replace('deraLayer_', '');
          if (evt.target.nextElementSibling.className == 'g-cartografia-check3') {
            evt.target.title = 'Elimina la capa ' + layerName + ' del mapa';
            evt.target.nextElementSibling.title = 'Elimina la capa ' + layerName + ' del mapa';
          } else {
            evt.target.title = 'Añade la capa ' + layerName + ' al mapa';
            evt.target.nextElementSibling.title = 'Añade la capa ' + layerName + ' al mapa';
          }
        }

      });
    });

    //  FUNCIONALIDAD SELECCIONAR-DESELECCIONAR CAPAS EN EL MAPA

    this.buttonsCheckLayers.forEach(button => {
      button.addEventListener('click', () => {
        button.classList.toggle('g-cartografia-check2');
        button.classList.toggle('g-cartografia-check3');
        let layerGroupName = button.parentNode.parentNode.id.replace('layers_', '');
        let layerName = button.parentNode.id.replace('deraLayer_', '');
        let layer = this.groupLayers.filter(obj => obj.groupName == layerGroupName)[0].layers.filter(obj => obj.name == layerName)[0];

        if (button.parentNode.parentNode.querySelectorAll('button.g-cartografia-check3').length != 0) {
          if (!button.parentNode.parentNode.parentNode.classList.contains('GroupDeraSelected')) {
            button.parentNode.parentNode.parentNode.classList.add('GroupDeraSelected');
          }
        } else {
          if (button.parentNode.parentNode.parentNode.classList.contains('GroupDeraSelected')) {
            button.parentNode.parentNode.parentNode.classList.remove('GroupDeraSelected');
          }
        }

        if (button.classList.contains('g-cartografia-check3')) {
          this.addDeraLayer(layer);
          button.title = 'Elimina la capa ' + layerName + ' del mapa';
          button.previousElementSibling.title = 'Elimina la capa ' + layerName + ' del mapa';
        } else {
          this.removeDeraLayer(layer);
          this.removeDeraLayerFromList(layer);
          button.title = 'Añade la capa ' + layerName + ' al mapa';
          button.previousElementSibling.title = 'Añade la capa ' + layerName + ' al mapa';

          let elementsDivDeraLayer = Array.from(document.querySelectorAll('div.listDeraLayer'));

          // ordenamos los elementos del divListDeraLayers según su order

          elementsDivDeraLayer.sort((a, b) => {
            if (parseInt(a.style.order) < parseInt(b.style.order)) {
              return 1;
            }
            if (parseInt(a.style.order) > parseInt(b.style.order)) {
              return -1;
            }
            return 0;
          });

          // reasignamos los zIndex de las capas SIEHAnd y modificamos su order en divListSIEHAndLayers

          for (let i = 0; i < elementsDivDeraLayer.length; i++) {
            let nameLayer = elementsDivDeraLayer[i].id.replace('legend_', '');
            this.map_.getLayers({ name: nameLayer })[0].setZIndex(2000 + i);
            document.querySelectorAll('div#legend_' + nameLayer)[0].style.order = (2000 + i) * (-1);
          }

          this.zIndexToSet = 2000 + elementsDivDeraLayer.length;


        }

      });
    });

    //  FUNCIONALIDAD BOTONES PAPELERA PARA ELIMINAR TODAS LAS CAPAS SELECCIONADAS DEL GRUPO

    this.buttonsRecycleBin.forEach(button => {
      button.addEventListener('click', (evt) => {
        let activedButtons = evt.target.parentNode.nextElementSibling.querySelectorAll('button.g-cartografia-check3');
        for (let button of activedButtons) {
          button.click();
        }
      });
    });



    //  RECUPERAMOS LAS CAPAS DE FONDO   

    this.map_.on(M.evt.COMPLETED, () => {
      let capas_fondoWMS = this.map_.getWMS().filter(obj => obj.getImpl().displayInLayerSwitcher == true);
      // la capa de fondo blanca es una capa WFS de las Provincias (DERA) con relleno y borde blanco
      let capas_fondoWFS = this.map_.getWFS().filter(obj => obj.getImpl().legend == "Fondo Blanco");
      let capas_fondo = capas_fondoWMS.concat(capas_fondoWFS);
      this.addDeraBaseLayerToList(capas_fondo);


      let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0] || document.querySelectorAll('div.m-panel.m-getfeatinf.opened.no-collapsible')[0];
      let maxExt = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

      
      if (!this.panel_.isCollapsed()) {        
          buttonInfo.classList.add('buttonInfoGrouped');
          maxExt.classList.add('ZoomGrouped');            
      }


    });

    //  MOVEMOS LOS PANELES SITUADOS EN BOTTOM RIGHT PARA QUE SEAN VISIBLES EN TODO MOMENTO

    this.panel_.on(M.evt.SHOW, () => {
      this.panelsBottomRight.forEach(panel => {
        panel.getTemplatePanel().classList.toggle('panelBottomRightOpened');
      });
      let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0] || document.querySelectorAll('div.m-panel.m-getfeatinf.opened.no-collapsible')[0];
      let maxExt = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

      buttonInfo.classList.add('buttonInfoGrouped');
      maxExt.classList.add('ZoomGrouped');
    });

    this.panel_.on(M.evt.HIDE, () => {
      this.panelsBottomRight.forEach(panel => {
        panel.getTemplatePanel().classList.toggle('panelBottomRightOpened');
      });
      let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0] || document.querySelectorAll('div.m-panel.m-getfeatinf.opened.no-collapsible')[0];
      let maxExt = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

      buttonInfo.classList.remove('buttonInfoGrouped');
      maxExt.classList.remove('ZoomGrouped');
    });

  }

  addMenus() {
    let addMenus = "<h2>Capas disponibles - DERA</h2>\n";
    let firstElem = true;

    this.groupLayers.forEach(groupLayer => {
      if (firstElem) {
        addMenus += "<div id='" + groupLayer.groupName + "' class='GroupDera firstElem'>\n<div class='divTitle'>\n<h3 id='title_" + groupLayer.groupName + "'  title='Despliega las capas del grupo " + groupLayer.groupName + "'>" + groupLayer.groupName + "</h3>\n<button class='g-cartografia-papelera' title='Elimina todas las capas seleccionadas del grupo " + groupLayer.groupName + "'></button>\n</div>\n<div id='layers_" + groupLayer.groupName + "' class='layersGroupDera oculta'>\n";
        firstElem = false;
      } else {
        addMenus += "<div id='" + groupLayer.groupName + "' class='GroupDera'>\n<div class='divTitle'>\n<h3 id='title_" + groupLayer.groupName + "'  title='Despliega las capas del grupo " + groupLayer.groupName + "'>" + groupLayer.groupName + "</h3>\n<button class='g-cartografia-papelera' title='Elimina todas las capas seleccionadas del grupo " + groupLayer.groupName + "'></button>\n</div>\n<div id='layers_" + groupLayer.groupName + "' class='layersGroupDera oculta'>\n";
      }
      addMenus += "</div>\n</div>\n"
    });

    this.divMenus.innerHTML = addMenus;

    this.groupLayers.forEach(groupLayer => {
      let addLayers = "";
      groupLayer.layers.forEach(layer => {
        addLayers += "<div id='deraLayer_" + layer.name + "' class='deraLayer'>\n<p title='Añade la capa " + layer.name + " al mapa'>" + layer.legend + "</p>\n<button class='g-cartografia-check2' title='Añade la capa " + layer.name + " al mapa'></button></div>\n"
      });
      this.divMenus.querySelectorAll('div#layers_' + groupLayer.groupName)[0].innerHTML = addLayers;

    });

  }

  addDeraLayer(layer) {
    let layerToCharge = new M.layer.WMS({
      url: layer.url,
      name: layer.name,
      legend: layer.legend,
      transparent: layer.transparent,
      tiled: layer.tiled,
      version: '1.3.0'
    },
      {
        layerDera: true
      });

    layerToCharge.setZIndex(this.zIndexToSet);

    this.zIndexToSet += 1;

    this.map_.addLayers(layerToCharge);

    layerToCharge.on(M.evt.LOAD, () => {
      this.addDeraLayerToList(layer);
    });

  }

  addDeraLayerToList(layer) {

    if (document.querySelectorAll('div#divListDeraLayers').length == 0) {
      this.divNoCapas.style.display = 'none';
      let contenedor = document.createElement('div');
      contenedor.id = 'divListDeraLayers';
      this.divCapasCargadas.appendChild(contenedor);
    }

    let order = this.map_.getWMS({ name: layer.name })[0].getZIndex() * (-1);

    let legend = layer.url + 'SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=' + layer.name + '&FORMAT=image/png&EXCEPTIONS=image/png';
    let dV = document.createElement('div');
    let textoToc;
    if (layer.legend.length > 30) {
      textoToc = layer.legend.slice(0, 30) + ' ...';
    } else {
      textoToc = layer.legend;
    }
    dV.className = 'listDeraLayer';
    dV.id = 'legend_' + layer.name;

    dV.innerHTML = '<div class="listDeraLayerControls">\n<button class="visibilityLegend g-cartografia-flecha-arriba2" title="oculta la leyenda"></button>\n<button class="visibilityLayer g-cartografia-check3" title="oculta la capa"></button>\n<p title="arrastra para ordenar la capa en el TOC">' + textoToc + '</p>\n<input type="range" data-layer-name="' + layer.name + '" class="m-managedera-transparency" min="0" max="1" step="0.1" value="1" title="control de transparencia">\n<button class="removeLayer g-cartografia-cancelar" title="elimina la capa"></button>\n</div>\n<div class="listDeraLayerLegend">\n<img data-layer-name="' + layer.name + '" src="' + legend + '">\n</div>';

    this.divCapasCargadas.children['divListDeraLayers'].appendChild(dV);

    document.getElementById('legend_' + layer.name).style.order = order;
    this.addFunctionLayerList(layer);

  }

  removeDeraLayer(layer) {
    this.map_.removeWMS({ name: layer.name });

    if (this.map_.getPopup() != null) {
      this.map_.removePopup(this.map_.getPopup());
    }
  }

  removeDeraLayerFromList(layer) {
    document.getElementById('legend_' + layer.name).remove();
    //  si no hay capas DERA cargadas eliminamos el titulo capas DERA
    if (document.querySelectorAll('div.listDeraLayer').length == 0) {
      document.getElementById('divListDeraLayers').remove();
      this.divNoCapas.style.display = 'block';
    }
  }

  addDeraBaseLayerToList(capas_fondo) {
    this.contentCapasFondo.innerHTML = "";
    let dV = document.createElement('div');
    dV.className = 'listDeraBaseLayer';
    dV.id = 'listDeraBaseLayer';
    capas_fondo.forEach(layer => {
      // layerDera se ha creado como opción en la creación de capas DERA para evitar que al activar maxextzoom muestre las capas DERA dentro de las capas de fondo
      if (typeof layer.getImpl().options.layerDera === 'undefined') {
        layer.setZIndex(1);
        let icon;
        if (layer.getImpl().visibility == true) {
          icon = 'g-cartografia-check5';
        } else {
          icon = 'g-cartografia-check4';
        }
        dV.innerHTML += '<div class="listDeraLayerControls" id="baseLayer_' + layer.getImpl().name + '">\n<button class="visibilityBaseLayer ' + icon + '"></button>\n<p>' + layer.getImpl().legend + '</p></div>\n<div class="listDeraBaseLayerLegend">\n<img data-layer-name="' + layer.getImpl().name + '" src="' + layer.getLegendURL() + '">\n</div>';

      }

    });

    this.contentCapasFondo.appendChild(dV);

    // AÑADIMOS LA FUNCIONALIDAD A LOS BOTONES

    let btnsVisibility = document.querySelectorAll('button.visibilityBaseLayer');
    btnsVisibility.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('g-cartografia-check4')) {
          let btnSelected = document.querySelectorAll('button.visibilityBaseLayer.g-cartografia-check5')[0];
          // botón anteriormente seleccionado       
          btnSelected.classList.toggle('g-cartografia-check5');
          btnSelected.classList.toggle('g-cartografia-check4');

          btn.classList.toggle('g-cartografia-check5');
          btn.classList.toggle('g-cartografia-check4');

          let nameBaseLayer = btn.parentNode.id.replace('baseLayer_', '');

          if (this.map_.getWMS({ name: nameBaseLayer }).length != 0) {
            this.map_.getWMS({ name: nameBaseLayer })[0].setVisible(true);
          } else {
            this.map_.getWFS({ name: nameBaseLayer })[0].setVisible(true);
          }

          //  solamente hacemos visible los portales y viales de CDAU cuando la capa CDAU_base sea visible

          if (nameBaseLayer == 'CDAU_base') {
            this.map_.getWMS({ name: 'CDAU_wms' })[0].setVisible(true);
          } else {
            this.map_.getWMS({ name: 'CDAU_wms' })[0].setVisible(false);
          }

          // ocultamos la capa anteriormente seleccionada
          nameBaseLayer = btnSelected.parentNode.id.replace('baseLayer_', '');

          if (this.map_.getWMS({ name: nameBaseLayer }).length != 0) {
            this.map_.getWMS({ name: nameBaseLayer })[0].setVisible(false);
          } else {
            this.map_.getWFS({ name: nameBaseLayer })[0].setVisible(false);
          }
        }
      });
    });
  }


  ordenaCapasMap(children) {
    for (let child of children) {
      let nameLayer = child.id.replace('legend_', '');
      let index = parseInt(child.style.order) * (-1);
      this.map_.getWMS({ name: nameLayer })[0].setZIndex(index);
    }
  }

  ordenaCapasToc(divToMove, index) {
    let children = document.getElementById('divListDeraLayers').children;
    let movedOrder = parseInt(divToMove.style.order);

    let indexSelected = index;

    if (movedOrder != indexSelected) {
      for (let child of children) {
        let currentOrder = parseInt(child.style.order);
        if (movedOrder > indexSelected) {
          if (child.id != divToMove.id) {
            if (currentOrder < movedOrder && currentOrder >= indexSelected) {
              child.style.order = currentOrder + 1;
            }
          } else {
            divToMove.style.order = indexSelected;
          }
        } else {
          if (child.id != divToMove.id) {
            if (currentOrder > movedOrder && currentOrder <= indexSelected) {
              child.style.order = currentOrder - 1;
            }
          } else {
            if (indexSelected > -2000) {
              divToMove.style.order = indexSelected - 1;
            } else {
              divToMove.style.order = indexSelected;
            }
          }
        }

      }

      this.ordenaCapasMap(children);

    }

  }

  addFunctionLayerList(layer) {
    let titulo = document.querySelectorAll('div#legend_' + layer.name + ' p')[0];
    let buttonRemoveLayer = document.querySelectorAll('div#legend_' + layer.name + ' button.removeLayer')[0];
    let buttonVisibilityLayer = document.querySelectorAll('div#legend_' + layer.name + ' button.visibilityLayer')[0];
    let opacityRange = document.querySelectorAll('div#legend_' + layer.name + ' input[type="range"]')[0];
    let buttonVisibilityLegend = document.querySelectorAll('div#legend_' + layer.name + ' button.visibilityLegend')[0];





    titulo.addEventListener('mousedown', (evt) => {

      let divToMove = evt.target.parentNode.parentNode;
      let elementMouseOver = false;
      let shiftY = evt.clientY - divToMove.getBoundingClientRect().top;
      let topeSup = document.getElementById('divListDeraLayers').getBoundingClientRect().top;
      let divCapas = document.getElementById('divListDeraLayers').children;

      let dimDivCapas = [];

      let transparencyDivToMove = divToMove.querySelectorAll('input.m-managedera-transparency')[0].value;

      if (document.querySelectorAll('div.listDeraLayer').length > 1) {
        divToMove.style.position = 'absolute';
        divToMove.style.zIndex = 10000;
        divToMove.style.opacity = 0.5;

        for (let div of divCapas) {
          if (div.id != divToMove.id) {
            let visibility;
            if (div.querySelectorAll('button.g-cartografia-flecha-arriba2').length == 0) {
              visibility = false;
            } else {
              visibility = true;
            }
            let elem = {
              id: div.id,
              order: div.style.order,
              top: null,
              bottom: null,
              visibility: visibility
            }
            dimDivCapas.push(elem);
          }
        }

        for (let div of divCapas) {
          if (div.id != divToMove.id) {
            if (div.querySelectorAll('button.g-cartografia-flecha-arriba2').length != 0) {
              div.querySelectorAll('button.g-cartografia-flecha-arriba2')[0].click();
            }
          }
        }

        dimDivCapas.sort((a, b) => {
          if (parseInt(a.order) > parseInt(b.order)) {
            return 1;
          }
          if (parseInt(a.order) < parseInt(b.order)) {
            return -1;
          }
          return 0;
        });

        let htmlElement1;
        let htmlElement2;

        if (dimDivCapas.length > 1) {
          for (let i = 0; i < dimDivCapas.length; i++) {

            if (i == 0) {
              htmlElement1 = document.getElementById(dimDivCapas[i].id);
              htmlElement2 = document.getElementById(dimDivCapas[i + 1].id);
              dimDivCapas[i].top = htmlElement1.getBoundingClientRect().top;
              dimDivCapas[i].bottom = Math.trunc(((htmlElement1.getBoundingClientRect().top - 10) + (htmlElement2.getBoundingClientRect().top - 10)) / 2);
            } else {
              if (i == dimDivCapas.length - 1) {
                htmlElement1 = document.getElementById(dimDivCapas[i].id);
                dimDivCapas[i].top = dimDivCapas[i - 1].bottom;
                dimDivCapas[i].bottom = htmlElement1.getBoundingClientRect().bottom;
              } else {
                htmlElement1 = document.getElementById(dimDivCapas[i].id);
                htmlElement2 = document.getElementById(dimDivCapas[i + 1].id);
                dimDivCapas[i].top = dimDivCapas[i - 1].bottom;
                dimDivCapas[i].bottom = Math.trunc(((htmlElement1.getBoundingClientRect().top - 10) + (htmlElement2.getBoundingClientRect().top - 10)) / 2);
              }
            }
          }
        } else {
          htmlElement1 = document.getElementById(dimDivCapas[0].id);
          dimDivCapas[0].top = htmlElement1.getBoundingClientRect().top;
          dimDivCapas[0].bottom = Math.trunc(htmlElement1.getBoundingClientRect().top + ((htmlElement1.getBoundingClientRect().height) / 2));
        }

      }

      function moveAt(pageY) {
        if (document.querySelectorAll('div.listDeraLayer').length > 1) {

          let idElementMouseOver;
          if (pageY > topeSup) {

            if (dimDivCapas.filter(obj => obj.top <= pageY && obj.bottom > pageY).length != 0) {
              idElementMouseOver = dimDivCapas.filter(obj => obj.top <= pageY && obj.bottom > pageY)[0].id;
            } else {
              if (pageY < dimDivCapas[0].top) {
                idElementMouseOver = dimDivCapas[0].id;
              } else {
                idElementMouseOver = dimDivCapas[dimDivCapas.length - 1].id;
              }
            }

            divToMove.style.top = pageY - shiftY + 'px';


            if (!elementMouseOver) {
              elementMouseOver = document.getElementById(idElementMouseOver);
              if (pageY < dimDivCapas[dimDivCapas.length - 1].bottom) {
                elementMouseOver.style.marginTop = '50px';
              }
            } else {
              if (pageY < dimDivCapas[dimDivCapas.length - 1].bottom && elementMouseOver.id == idElementMouseOver) {
                elementMouseOver = document.getElementById(idElementMouseOver);
                elementMouseOver.style.marginTop = '50px';
              }
              if (elementMouseOver.id != idElementMouseOver) {
                elementMouseOver.style.removeProperty('margin-top');

                elementMouseOver = document.getElementById(idElementMouseOver);
                elementMouseOver.style.marginTop = '50px';
              }
              if (pageY > dimDivCapas[dimDivCapas.length - 1].bottom) {
                elementMouseOver.style.removeProperty('margin-top');
              }

            }
          }
        }
      }


      function onMouseMove(evt) {
        moveAt(evt.pageY);
      }

      if (document.querySelectorAll('div.listDeraLayer').length > 1) {

        divToMove.style.left = '20px';

        moveAt(evt.pageY);
        document.addEventListener('mousemove', onMouseMove);


        divToMove.addEventListener('mouseup', (evt) => {
          let divTarget = dimDivCapas.filter(obj => obj.top <= evt.pageY && obj.bottom > evt.pageY);

          let indexDivToMove = parseInt(document.getElementById(divToMove.id).style.order);

          let index;

          if (divTarget.length == 0) {
            if (evt.pageY > dimDivCapas[dimDivCapas.length - 1].bottom) {
              divTarget = [dimDivCapas[dimDivCapas.length - 1]];
            } else {
              divTarget = [dimDivCapas[0]];
            }
          }

          if (indexDivToMove < parseInt(divTarget[0].order)) {
            if (elementMouseOver.style.marginTop) {
              index = parseInt(divTarget[0].order) - 1;
            } else {
              index = parseInt(divTarget[0].order);
            }
          } else {
            if (dimDivCapas[dimDivCapas.length - 1].bottom < evt.pageY) {
              index = parseInt(divTarget[0].order) + 1;
            } else {
              index = parseInt(divTarget[0].order);
            }
          }

          elementMouseOver.style.removeProperty('margin-top');

          document.removeEventListener('mousemove', onMouseMove);

          divToMove = document.getElementById(divToMove.id);
          divToMove.style.removeProperty('position');
          divToMove.style.removeProperty('z-index');
          divToMove.style.removeProperty('top');
          divToMove.style.removeProperty('left');
          divToMove.style.removeProperty('opacity');

          this.ordenaCapasToc(divToMove, index);

          let classDiv = divToMove.className;
          let idDiv = divToMove.id;
          let orderDiv = divToMove.style.order;
          let contentDiv = divToMove.innerHTML;

          //  eliminamos el div movido para eliminar así también el evento mouseup asociado a él

          document.getElementById('divListDeraLayers').removeChild(document.getElementById(idDiv));

          //  lo volvemos a crear y lo insertamos en divListDeraLayers

          let newDiv = document.createElement('div');
          newDiv.className = classDiv;
          newDiv.id = idDiv;
          newDiv.style.order = orderDiv;

          newDiv.innerHTML = contentDiv;


          newDiv.querySelectorAll('input.m-managedera-transparency')[0].value = transparencyDivToMove;
          document.getElementById('divListDeraLayers').appendChild(newDiv);

          let idG = idDiv.replace('legend_g', '').substr(0, 2);
          if (idG[0] == 0) {
            idG = idG.substr(1, 1);
          }

          //  volvemos a añadir los eventos al div movido anteriormente

          this.addFunctionLayerList(this.groupLayers.filter(obj => obj.groupName.includes('G' + idG))[0].layers.filter(obj => obj.name == idDiv.replace('legend_', ''))[0]);

          //  si las leyendas estaban desplegadas antes de mover el div las volvemos a desplegar

          for (let elem of dimDivCapas) {
            if (elem.visibility) {
              if (document.querySelectorAll('div#' + elem.id + ' button.g-cartografia-flecha-abajo2').length != 0) {
                document.querySelectorAll('div#' + elem.id + ' button.g-cartografia-flecha-abajo2')[0].click();
              }
            }
          }
        });

      }

    });


    buttonVisibilityLayer.addEventListener('click', () => {
      if (buttonVisibilityLayer.classList.contains('g-cartografia-check3')) {
        this.map_.getWMS({ name: layer.name })[0].setVisible(false);
        buttonVisibilityLayer.title = 'hace visible la capa';
      } else {
        this.map_.getWMS({ name: layer.name })[0].setVisible(true);
        buttonVisibilityLayer.title = 'oculta la capa';
      }
      buttonVisibilityLayer.classList.toggle('g-cartografia-check3');
      buttonVisibilityLayer.classList.toggle('g-cartografia-check2');

    });

    buttonRemoveLayer.addEventListener('click', () => {
      this.map_.removeWMS({ name: layer.name });
      document.getElementById('deraLayer_' + layer.name).querySelectorAll('button')[0].click();
      let elementsDivDeraLayer = Array.from(document.querySelectorAll('div.listDeraLayer'));

      // ordenamos los elementos del divDeraLayers según su order
      elementsDivDeraLayer.sort((a, b) => {
        if (parseInt(a.style.order) < parseInt(b.style.order)) {
          return 1;
        }
        if (parseInt(a.style.order) > parseInt(b.style.order)) {
          return -1;
        }
        return 0;
      });

      // reasignamos los zIndex de las capas DERA y modificamos su order en divListDeraLayers

      for (let i = 0; i < elementsDivDeraLayer.length; i++) {
        let nameLayer = elementsDivDeraLayer[i].id.replace('legend_', '');
        this.map_.getWMS({ name: nameLayer })[0].setZIndex(2000 + i);
        document.querySelectorAll('div#legend_' + nameLayer)[0].style.order = (2000 + i) * (-1);
      }

      this.zIndexToSet = 2000 + elementsDivDeraLayer.length;
    });


    opacityRange.addEventListener('change', () => {
      this.map_.getWMS({ name: layer.name })[0].setOpacity(parseFloat(opacityRange.value));
    });

    buttonVisibilityLegend.addEventListener('click', () => {
      if (buttonVisibilityLegend.classList.contains('g-cartografia-flecha-arriba2')) {
        document.querySelectorAll('div#legend_' + layer.name + '>div.listDeraLayerLegend')[0].style.display = 'none';
        buttonVisibilityLegend.title = 'muestra la leyenda';
      } else {
        document.querySelectorAll('div#legend_' + layer.name + '>div.listDeraLayerLegend')[0].style.display = 'block';
        buttonVisibilityLegend.title = 'oculta la leyenda';
      }
      buttonVisibilityLegend.classList.toggle('g-cartografia-flecha-arriba2');
      buttonVisibilityLegend.classList.toggle('g-cartografia-flecha-abajo2');
    });

  }

}
